import { render, staticRenderFns } from "./CartListItem.vue?vue&type=template&id=20dd2174"
import script from "./CartListItem.vue?vue&type=script&lang=ts"
export * from "./CartListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports